import { ReactElement, useState } from "react";
import { Toolbar } from "client/Components";
import styles from "./TextAndToolbar.module.less";
import classNames from "classnames";

export type TextAndToolbarProps = {
	text: ReactElement | string;
	toolbarItems: ReactElement | null;
	shouldRenderBackdrop: boolean;
};

export const TextAndToolbar = (props: TextAndToolbarProps): ReactElement => {
	const {
		text,
		toolbarItems,
		shouldRenderBackdrop
	} = props;

	const [toolbarMaxWidth, setToolbarMaxWidth] = useState<number>(0);

	return (
		<div
			className={classNames(
				styles.root,
				{[styles.root_hasBackdrop]: shouldRenderBackdrop}
			)}
		>
			<h2 className={styles.title}>
				{text}
			</h2>
			<div className={styles.toolbar} style={{flexBasis: toolbarMaxWidth + 1}}>
				<Toolbar
					horizontalAlignment="right"
					moreButtonKind="secondary"
					buttonSize="large"
					onMaxContentWidthChange={setToolbarMaxWidth}
					trackingId="workspace-actions"
				>
					{toolbarItems}
				</Toolbar>
			</div>
		</div>
	);
};
TextAndToolbar.displayName = "TextAndToolbar";